// extracted by mini-css-extract-plugin
export default {"form_container":"AddBourbonForm_form_container__5jnDc","empty_container":"AddBourbonForm_empty_container__Pcu0i","gradient-animation":"AddBourbonForm_gradient-animation__M82oM"};